<div class="nofondPage unity-padding-web unity-padding-h5-12">
  <div class="nofondPage-content">
    <div class="nofondPage-content-top">
      <img src="assets/images/nofondpage.jpg" alt="" />
    </div>
    <div class="nofondPage-content-bottom">
      <span class="tips">OOPS</span>
      <span class="text"
        >You got a 404. That means this page doesn’t exist or has been moved. No worries, let us get you back on
        track!</span
      >
      <cs-button label="Back to Home" width="auto" (buttonClick)="goHome()"></cs-button>
    </div>
  </div>
</div>
